import { IAddress } from "@app/shared/shared.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const addressAdapter: EntityAdapter<IAddress> = createEntityAdapter<IAddress>({
	selectId: address => address.id
});